<app-navbar-style-two></app-navbar-style-two>

<section class="hero slant-bottom">
  <picture>
    <source media="(max-width: 768px)" srcset="assets/img/products/hero-mob.png">
    <img src="assets/img/products/hero-bg.png" alt="hero" />
  </picture>
</section>
<div class="contain">
<!-- PRODUCT SECTIONS -->
<section *ngFor="let section of sections; let i = index" 
  [style.background-color]="section.bg"
  [style.color]="section.textColor" 
  [ngClass]="{
    'CategoriesSection': section.type !== 'brochure',
    'category-odd': section.type !== 'brochure' && i % 2 === 0,
    'category-even': section.type !== 'brochure' && i % 2 === 1,
    'no-slant': section.type === 'brochure',
    'brochure': section.type === 'brochure',
    'first-section': i === 0
  }">
  <!-- NORMAL PRODUCT SECTION -->
  <ng-container *ngIf="section.type !== 'brochure'">
    <div class="container-fluid split" [class.reverse]="section.reverse">
      <div class="content">
        <h2 class="text-white">{{ section.title }}</h2>
        <p>{{ section.description }}</p>

        <div class="brands" *ngIf="section.brands?.length">
          <div class="brand-item" *ngFor="let brand of section.brands">
            <img [src]="brand" loading="lazy" alt="Brand" />
          </div>
        </div>

        <a routerLink="/shop" class="explore-btn">Explore Now</a>
      </div>

      <img [src]="section.image" [alt]="section.title" loading="lazy" class="imag" />
    </div>
  </ng-container>

  <!-- BROCHURE SECTION -->
  <ng-container *ngIf="section.type === 'brochure'">
    <div class="container-fluid brochure-content">
      <div>
        <h2>{{ section.title }}</h2>
        <p>{{ section.description }}</p>
      </div>

      <button class="brochure-btn">Download Now</button>
    </div>
  </ng-container>
</section>
</div>
<app-footer-style-one></app-footer-style-one>